export function addSeparator(value: string, n: number, separator: string = ' ') {
    const regex = new RegExp(`.{1,${n}}`, 'g');
    const matches = value.match(regex) || [];

    return matches.join(separator);
}
